import { Stack, Typography } from '@mui/material';
import React from 'react';
import type { ReportType } from '../reports-page-types/report-type';
import type { TabContainerProps } from './TabContainer';
import { TabContainer } from './TabContainer';

type ReportTabProps = Omit<TabContainerProps, 'onClick'> & {
  title: ReportType;
  count: number;
  onClick: (reportType: ReportType) => void;
};

export const ReportTab: React.FC<ReportTabProps> = ({ title, count, onClick, isActive = false, ...props }) => {
  return (
    <TabContainer
      isActive={isActive}
      onClick={() => onClick(title)}
      {...props}
    >
      <Stack
        direction='row'
        alignItems="center"
        flexGrow={1}
        gap='12px'
      >
        <Typography
          sx={{
            fontWeight: '500',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            wordWrap: 'break-word',
            color: 'rgba(27, 61, 85, 0.60)',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant='h6'
          letterSpacing={0.15}
          marginLeft='auto'
        >
          {count}
        </Typography>
      </Stack>
    </TabContainer>
  );
};